exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".low-b-copy[data-v-682fc3ce]{padding:30px 20px;min-width:480px}.low-b-copy .text1[data-v-682fc3ce]{line-height:42px;font-size:16px}.low-b-copy .text2[data-v-682fc3ce]{line-height:50px;font-size:14px;color:#8e8e8e}.low-b-copy .copy-input[data-v-682fc3ce]{width:100%;border:none;height:60px}", ""]);

// exports
